import { useWordPressPosts } from "../hook/wordpress/posts.wordpress.hook";
import { useMe } from "../hook/partner/authentication/me.partner.hook";
import { useAuthStore } from "../store/auth.store";
import { useLogin } from "../hook/partner/authentication/login.partner.hook";
import { useEffect, useState } from "react";
import { useDealsStore } from "../store/deals.store";
import { useDeals } from "../hook/partner/deals.partner.hook";
import { PartnerApi } from "../api/partner.api";
import { Pagination } from "../components/List/Pagination";
import { usePopper } from "react-popper";
import { useDealsTableStore } from "../store/dealsTable.store";
import { useBreadcrumbsStore } from "../store/breadcrumbs.store";
import OpportunityNewModal from "../components/modals/opportunity/OpportunityNewModal";
import DealNewModal from "../components/modals/deal/DealNewModal";
import { NavLink } from "react-router";
import { InvoiceFilter } from "../components/Invoice/InvoiceFilter";
import { DealFilter } from "../components/Deal/DealFilter";
import { InvoiceFilterActual } from "../components/Invoice/InvoiceFilterActual";
import { DealFilterActual } from "../components/Deal/DealFilterActual";
import AnchorData from "../utils/AnchorData";
import { FulltextFilter } from "../components/List/FulltextFilter";
import {RowSelector} from "../components/List/RowSelector";
import InvoiceTable from "../components/Invoice/InvoiceTable";
import DealTable from "../components/Deal/DealTable";
import { useTranslation } from "../hooks/useTranslation";

function Deals() {
  const { t } = useTranslation();
  const dealsMutation = useDeals();
  const [page, setPage] = useState(1);

  const deal_filter = JSON.parse(localStorage.getItem("deal_filter"));

  const anchorData = AnchorData();
  const current_state_id = [];
  anchorData?.pageAllow === true && current_state_id.push("1");
  anchorData?.pageDisallow === true && current_state_id.push("-1");

  const [filter, setFilter] = useState(
    anchorData
      ? {
          current_state_id: current_state_id,
        }
      : {
          ...deal_filter,
          current_state_id: deal_filter?.current_state_id || current_state_id,
        }
  );

  const [showModalNew, setShowModalNew] = useState(false);

  const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
  const setPagename = useBreadcrumbsStore((state) => state.setPagename);
  useEffect(() => {
    setPagename(t("deals.registration"));
    setBreadcrumbs([]);
  }, []);

  const [rowsSelected, setRows] = useState(10);

  const [sortTable, setSortTable] = useState({
    sort: "deal_id",
    sortDirection: "desc",
  });

  const token = useAuthStore((state) => state.token);
  const deals = useDealsStore((state) => state.deals);

  useEffect(() => {
    if (token) {
      dealsMutation.mutate({ token, page, filter, rowsSelected, sortTable });
      localStorage.setItem("deal_filter", JSON.stringify(filter));
    }
  }, [token, page, filter, rowsSelected, sortTable]);

  /* Dynamická tabulka */

  const selectedColumns = useDealsTableStore((state) => state.selectedColumns);
  const toggleColumn = useDealsTableStore((state) => state.toggleColumn);
  const getAvailableColumns = useDealsTableStore((state) => state.getAvailableColumns);
  const awailableColumns = getAvailableColumns();

  return (
    <>
      <div className="card mt-6">
        <div className="card-header border-0 pt-6">
          <div className="card-title">
            <FulltextFilter
              onChange={(e) =>
                setFilter({
                  ...filter,
                  fulltext: e.target.value,
                })
              }
              placeholder={t("deals.searchRegistration")}
            />
            &nbsp;
            <button
              className="btn btn-success"
              onClick={() =>
                PartnerApi.dealsExport({ token, filter, rowsSelected, sortTable })
              }
            >
              Export XLSX
            </button>
          </div>

          <div className="card-toolbar">
            <div
              className="d-flex justify-content-end"
              data-kt-customer-table-toolbar="base"
            >
              <DealNewModal
                show={showModalNew}
                handleClose={() => setShowModalNew(false)}
              />

              <DealFilter
                awailableColumns={awailableColumns}
                selectedColumns={selectedColumns}
                toggleColumn={toggleColumn}
                setFilter={setFilter}
                filter={filter}
                setShowModalNew={setShowModalNew}
              />
            </div>
          </div>
        </div>

        <div className="card-body pt-0">
          <div className="border-top border-bottom py-3">
            {t("common.totalCount")}: {deals?.rows}
          </div>
          <DealFilterActual setFilter={setFilter} filter={filter} />

          <DealTable
              deals={deals}
              awailableColumns={awailableColumns}
              selectedColumns={selectedColumns}
              sortTable={sortTable}
              setSortTable={setSortTable}
          />
        </div>
      </div>

      {deals?.rows > 0 && (
          <>
            <Pagination
                total_pages={deals.total_pages}
                rows_per_page={deals.rows_per_page}
                page={page}
                setPage={setPage}
            />
            <RowSelector setRows={setRows} />
          </>
      )}
    </>
  );
}

export default Deals;
